import { Attributes } from '@leverege/ui-attributes';
import Path from '@leverege/path';
import { Types } from "../../constants/index.js";
window.levPath = Path;
export default function SubField({
  baseAttrName,
  baseAttrField,
  field,
  displayName,
  valueType,
  creatable,
  editable,
  objectType,
  createOptions,
  editOptions,
  getDefaultValue
}) {
  const pathAcc = Path(field);
  return {
    name: `${baseAttrName}.${field.split('/').join('.')}`,
    objectType,
    valueType,
    get: (data, cxt) => {
      const val = Attributes.get(baseAttrName, objectType, data);
      return pathAcc.get(val);
    },
    set: (data, value, cxt) => {
      const val = Attributes.get(baseAttrName, objectType, data);
      return {
        ...data,
        [baseAttrField]: pathAcc.copy(val ?? {}, value)
      };
    },
    canSet: () => true,
    getPatch: (data, value, cxt) => {
      return {
        path: `${baseAttrField}/${field}`,
        value
      };
    },
    getDefaultValue,
    displayName,
    source: {
      type: Types.apiName,
      editable,
      creatable,
      createOptions,
      editOptions
    }
  };
}